/**
 * Opens a presigned S3 URL as a file download. Do not attach auth headers to the fetch —
 * they break the S3 signature.
 */
export function openPresignedDownload(downloadUrl: string, filename?: string): void {
  if (!downloadUrl) {
    return;
  }

  const safeName = filename || 'download';

  fetch(downloadUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Download failed');
      }
      return response.blob();
    })
    .then((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = safeName;
      anchor.rel = 'noopener';
      anchor.click();
      URL.revokeObjectURL(objectUrl);
    })
    .catch(() => {
      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      if (filename) {
        anchor.download = filename;
      }
      anchor.click();
    });
}

export function getWhatsAppDocumentsErrorMessage(err: any): string {
  const status = err && err.status;
  const message =
    (err && err.error && (err.error.message || err.error.error)) ||
    (typeof err === 'string' ? err : '');

  if (status === 404) {
    return message || 'No WhatsApp documents found.';
  }
  if (status === 413) {
    return message || 'Too many files to download. Please try a smaller scope or contact support.';
  }
  if (status === 400) {
    return message || 'Invalid request. Project ID is required.';
  }
  return message || 'Failed to prepare WhatsApp documents download.';
}
